'use client';
import { ensureNativeModulesAreInstalled } from './ensureNativeModulesAreInstalled';
ensureNativeModulesAreInstalled();
export const NativeModule = globalThis.expo.NativeModule;

//# sourceMappingURL=NativeModule.js.map
